export default "__VITE_ASSET__4213a033__"